// extracted by mini-css-extract-plugin
module.exports = {"templateImg":"styles_templateImg__iobVw","messageImageAnimation":"styles_messageImageAnimation__3izdP"};